import { useEffect } from "react";
import Navbar from "../components/Navbar";
import jwt_decode from "jwt-decode";
import { useState } from "react";
import { isUserValid, loginOAuth } from "../lib/pocketbase";

export default function Auth2Page() {
    const [user, setUser] = useState({});

    function handleCallbackResponse(response) {
        //console.log("Encoded JWT ID Token: " + response.credential);
        var userObject = jwt_decode(response.credential);
        console.log(userObject);
        setUser(userObject);
        document.getElementById("customSignInButton").hidden = true;
    }

    function handleSignout(event) {
        setUser({});
        document.getElementById("customSignOutButton").hidden = true;
    }

    useEffect(() => {
        /* global google */
        google.accounts.id.initialize({
            client_id: "308462231943-0hlh6avg60olgs7lmoe93pqaiqe2hme0.apps.googleusercontent.com",
            callback: handleCallbackResponse
        });
    }, []);

    let redirectURL = "http://localhost:3000/"
    const params = (new URL(window.location)).searchParams;
    const provider = JSON.parse(localStorage.getItem('provider'))

    function handleSubmit() {
        //loginOAuth(params.get("code"), provider[0].codeVerifier,redirectURL)
    }

    return (
        <div className="text-base-content">
            <Navbar />
            <article className="prose text-lg mx-auto m-5">
                <h1>Auth 2 Page</h1>
            </article>

            {Object.keys(user).length === 0 && (
                <button
                    id="customSignInButton"
                    className="btn btn-primary"
                    onClick={()=> google.accounts.id.prompt()}
                >
                    Sign In with Google
                </button>
            )}

            {Object.keys(user).length !== 0 && (
                <div>
                    <img className="mx-auto mb-3" src={user.picture} alt="Profile"></img>
                    <h3 className="mx-auto mb-5">{user.name}</h3>
                </div>
            )}

            {Object.keys(user).length !== 0 && (
                <button id="customSignOutButton" className="btn btn-primary" onClick={(e) => handleSignout(e)}>
                    Sign Out
                </button>
            )}

            <button className="btn btn-secondary m-5" onClick={handleSubmit}>Login with pb</button>

        </div>
    );
}